import { FIRESTORE_DOC_CHANGE_TYPES } from 'Modules/Spaces/show/constants';
import { InvalidDocChangeTypeError } from 'Modules/Spaces/show/sagas/firestore/utils/errors';

/**
 * Separates document changes returned by a Firestore collection
 * callback into 3 types: added, modified, or removed
 *
 * @param {docChanges} firestore.collection('path/to/col').onSnapshot(snapshot => snapshot.docChanges)
 *
 * @return {Object}
 * */
export default function seperateByDocChangeType(docChanges) {
  const added = [];
  const modified = [];
  const removed = [];

  for (const docChange of docChanges) {
    const { type, doc } = docChange;

    switch (type) {
      case FIRESTORE_DOC_CHANGE_TYPES.ADDED: {
        added.push(doc);
        break;
      }

      case FIRESTORE_DOC_CHANGE_TYPES.MODIFIED: {
        modified.push(doc);
        break;
      }

      case FIRESTORE_DOC_CHANGE_TYPES.REMOVED: {
        removed.push(doc);
        break;
      }

      default:
        throw new InvalidDocChangeTypeError(docChange.type);
    }
  }

  return { added, modified, removed };
}
